import { SalaryInitializer as GlobalInitializer } from '@teamworks/global';

export class SalaryInitializer {

  static initialize() {
    GlobalInitializer.initialize();
  }

}
